import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { CalendarDayItemStyled } from "./styled";
import { RENDER_BOOKING_STATUS_COLOR } from "utils/functions/musicHall";
import { AlertControl } from "components/Modals/Alert";

const CalendarDayItem = ({
  theme_standard,
  division,
  bookerName,
  eventName,
  status,
  isHoliday,
  onClick,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const _handleClick = () => {
    if (onClick) {
      AlertControl.show({
        title: "ยืนยันการปิดวัน",
        description: "คุณต้องการจะปิดวันใช่หรือไม่",
        btnLabel1: "ยกเลิก ",
        btnLabel2: "ยืนยัน",
        onEvent2: async () => {
          onClick();
        },
      });
    }
  };

  const renderStatus = RENDER_BOOKING_STATUS_COLOR(status);
  return (
    <CalendarDayItemStyled
      className={customClass}
      isHoliday={isHoliday}
      indicatorColor={isHoliday ? "#6e6e6e" : renderStatus.bgColor}
      onClick={_handleClick}
    >
      <div className="status-indicator" />
      <div className="cld_row">
        <div className="cld_phone">{bookerName}</div>
        <div className="cld_product">{eventName}</div>
      </div>
    </CalendarDayItemStyled>
  );
};

CalendarDayItem.propTypes = {};

export default CalendarDayItem;
